export default "__VITE_ASSET__DHg8N71m__"